// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_V8R","cls2":"ProfilePdfPackCard-cls2__fI ProfilePdfPackCard-cls1_V8R"};